import { render, staticRenderFns } from "./BelposhtaFilter.vue?vue&type=template&id=4cd79ecd&scoped=true"
import script from "./BelposhtaFilter.vue?vue&type=script&lang=js"
export * from "./BelposhtaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd79ecd",
  null
  
)

export default component.exports